import { render } from "./RotationBlocker.vue?vue&type=template&id=5e5156e6&scoped=true&ts=true"
import script from "./RotationBlocker.vue?vue&type=script&lang=ts"
export * from "./RotationBlocker.vue?vue&type=script&lang=ts"

import "./RotationBlocker.vue?vue&type=style&index=0&id=5e5156e6&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5156e6"]])

export default __exports__